import styled from 'styled-components';
import colors from '../../constant/colors';

const blue = '#097EB7';
const green = '#2AAB6C';
const ink = '#1C2134';
const muted = '#5E6B7D';
const line = '#E4EAF1';

export const StyledContainer = styled.div`
  font-family: Poppins, sans-serif;
  color: ${ink};
  background: #ffffff;
  overflow-x: hidden;

  .guide-section {
    padding: 72px 0;
  }
  .guide-section.alt {
    background: #F5F9FC;
  }

  .section-heading {
    text-align: center;
    max-width: 680px;
    margin: 0 auto 44px;
  }
  .section-heading .eyebrow {
    display: inline-block;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: ${green};
    margin-bottom: 10px;
  }
  .section-heading h2 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 12px;
    color: ${ink};
  }
  .section-heading p {
    font-size: 16px;
    color: ${muted};
    margin: 0;
  }

  /* ---------- Hero ---------- */
  .guide-hero {
    background: ${colors.linearGradiant};
    color: #ffffff;
    padding: 140px 0 80px;
    position: relative;
  }
  .guide-hero::after {
    content: '';
    position: absolute;
    right: -120px;
    top: -120px;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    pointer-events: none;
  }
  .guide-hero .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.18);
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 18px;
  }
  .guide-hero h1 {
    color: #ffffff;
    font-size: 44px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 16px;
  }
  .guide-hero .hero-text {
    font-size: 17px;
    line-height: 1.7;
    opacity: 0.95;
    max-width: 560px;
    margin-bottom: 28px;
  }
  .store-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  .store-buttons img {
    height: 46px;
    width: auto;
    border-radius: 8px;
  }
  .store-link {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 500;
    color: inherit;
    text-decoration: none;
  }
  .store-link:hover {
    color: inherit;
  }

  /* ---------- App download cards ---------- */
  .app-card {
    background: #ffffff;
    border: 1px solid ${line};
    border-radius: 20px;
    padding: 28px 24px;
    text-align: center;
    box-shadow: 0 10px 30px rgba(9, 47, 84, 0.08);
  }
  .app-card h4 {
    font-size: 22px;
    font-weight: 600;
    margin: 10px 0 8px;
  }
  .app-card > p {
    color: ${muted};
    font-size: 14px;
    margin-bottom: 18px;
  }
  .app-card .device-type {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: ${blue};
  }
  .app-card .qr-sub {
    font-size: 13px;
    color: ${muted};
    margin: 12px 0 16px;
  }
  .app-store-buttons {
    justify-content: center;
    margin-bottom: 16px;
  }
  .app-card .coming-soon {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: ${muted};
    background: #F5F9FC;
    border: 1px dashed ${line};
    border-radius: 999px;
    padding: 6px 14px;
    margin: 0 0 16px;
  }

  .hero-points {
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
    margin-top: 28px;
    font-size: 14px;
  }
  .hero-points span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  /* ---------- QR card ---------- */
  .qr-card {
    position: relative;
    z-index: 1;
    background: #ffffff;
    color: ${ink};
    border-radius: 20px;
    padding: 28px 24px;
    box-shadow: 0 20px 50px rgba(9, 47, 84, 0.25);
    text-align: center;
    max-width: 390px;
    margin: 0 auto;
  }
  .qr-card h3 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .qr-card .qr-sub {
    font-size: 14px;
    color: ${muted};
    margin-bottom: 18px;
  }
  .qr-frame {
    display: inline-block;
    padding: 10px;
    border-radius: 16px;
    border: 2px dashed ${line};
  }
  .qr-frame canvas {
    display: block;
    max-width: 100%;
    height: auto !important;
  }
  .qr-link {
    margin: 14px 0 18px;
    font-size: 13px;
    color: ${blue};
    word-break: break-all;
  }
  .qr-actions {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
  }
  .guide-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    padding: 0 16px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    font-family: Poppins, sans-serif;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    border: none;
    text-decoration: none;
  }
  .guide-btn:hover {
    transform: translateY(-1px);
    text-decoration: none;
  }
  .guide-btn svg {
    font-size: 18px;
  }
  .guide-btn.primary {
    background: ${colors.primary};
    color: #ffffff;
    box-shadow: 0 6px 16px rgba(42, 171, 108, 0.3);
  }
  .guide-btn.outline {
    background: #ffffff;
    color: ${ink};
    border: 1px solid ${line};
  }
  .guide-btn.light {
    background: #ffffff;
    color: ${blue};
  }

  /* ---------- Steps ---------- */
  .step-card {
    position: relative;
    height: 100%;
    background: #ffffff;
    border: 1px solid ${line};
    border-radius: 18px;
    padding: 28px 22px 24px;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
  }
  .step-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 34px rgba(9, 126, 183, 0.12);
  }
  .step-number {
    position: absolute;
    top: 18px;
    right: 20px;
    font-size: 34px;
    font-weight: 700;
    color: #EDF3F8;
    line-height: 1;
  }
  .icon-circle {
    width: 54px;
    height: 54px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${colors.linearGradiant};
    color: #ffffff;
    margin-bottom: 18px;
  }
  .icon-circle svg {
    font-size: 28px;
  }
  .step-card h4 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  .step-card p {
    font-size: 14px;
    color: ${muted};
    line-height: 1.65;
    margin: 0;
  }

  /* ---------- Devices ---------- */
  .device-card {
    height: 100%;
    background: #ffffff;
    border-radius: 18px;
    padding: 26px 22px;
    box-shadow: 0 6px 24px rgba(28, 33, 52, 0.06);
    border-top: 4px solid ${green};
  }
  .device-card:nth-child(even) {
    border-top-color: ${blue};
  }
  .device-card .device-type {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: ${muted};
  }
  .device-card h4 {
    font-size: 19px;
    font-weight: 600;
    margin: 4px 0 10px;
  }
  .device-card p {
    font-size: 14px;
    color: ${muted};
    line-height: 1.6;
    margin-bottom: 14px;
  }
  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .chip {
    font-size: 12px;
    font-weight: 500;
    padding: 5px 10px;
    border-radius: 999px;
    background: #EAF6F0;
    color: #1F7A4F;
  }

  /* ---------- Connect timeline ---------- */
  .timeline {
    list-style: none;
    padding: 0;
    margin: 0;
    counter-reset: connect;
  }
  .timeline li {
    position: relative;
    padding: 0 0 26px 62px;
    counter-increment: connect;
  }
  .timeline li::before {
    content: counter(connect);
    position: absolute;
    left: 0;
    top: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${colors.linearGradiant};
    color: #ffffff;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .timeline li::after {
    content: '';
    position: absolute;
    left: 19px;
    top: 44px;
    bottom: 4px;
    width: 2px;
    background: ${line};
  }
  .timeline li:last-child {
    padding-bottom: 0;
  }
  .timeline li:last-child::after {
    display: none;
  }
  .timeline h5 {
    font-size: 17px;
    font-weight: 600;
    margin: 8px 0 4px;
  }
  .timeline p {
    font-size: 14px;
    color: ${muted};
    line-height: 1.65;
    margin: 0;
  }

  .info-panel {
    background: #ffffff;
    border: 1px solid ${line};
    border-radius: 18px;
    padding: 24px;
    margin-bottom: 20px;
  }
  .info-panel h5 {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 17px;
    font-weight: 600;
    margin-bottom: 14px;
  }
  .info-panel h5 svg {
    color: ${green};
  }
  .info-panel ul {
    padding-left: 0;
    list-style: none;
    margin: 0;
  }
  .info-panel li {
    display: flex;
    gap: 10px;
    font-size: 14px;
    color: ${muted};
    line-height: 1.6;
    margin-bottom: 10px;
  }
  .info-panel li:last-child {
    margin-bottom: 0;
  }
  .info-panel li svg {
    flex-shrink: 0;
    font-size: 18px;
    margin-top: 2px;
    color: ${green};
  }
  .info-panel.notice {
    background: #FFF8E6;
    border-color: #F5DFA3;
  }
  .info-panel.notice h5 svg {
    color: #C98A00;
  }

  /* ---------- FAQ ---------- */
  .faq-wrap {
    max-width: 820px;
    margin: 0 auto;
  }
  .faq-wrap .MuiAccordion-root {
    border: 1px solid ${line};
    border-radius: 14px !important;
    box-shadow: none;
    margin-bottom: 12px;
    font-family: Poppins, sans-serif;
  }
  .faq-wrap .MuiAccordion-root::before {
    display: none;
  }
  .faq-wrap .MuiAccordionSummary-content p {
    font-family: Poppins, sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: ${ink};
    margin: 0;
  }
  .faq-wrap .MuiAccordionDetails-root p {
    font-family: Poppins, sans-serif;
    font-size: 14px;
    color: ${muted};
    line-height: 1.7;
    margin: 0;
  }

  /* ---------- Help CTA ---------- */
  .help-cta {
    background: ${colors.linearGradiant};
    border-radius: 22px;
    padding: 40px 32px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
  }
  .help-cta h3 {
    color: #ffffff;
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .help-cta p {
    margin: 0;
    opacity: 0.95;
  }

  @media (max-width: 991px) {
    .guide-hero {
      padding: 110px 0 60px;
    }
    .guide-hero h1 {
      font-size: 34px;
    }
    .qr-card {
      margin-top: 40px;
    }
  }

  @media (max-width: 575px) {
    .guide-section {
      padding: 52px 0;
    }
    .guide-hero h1 {
      font-size: 28px;
    }
    .section-heading h2 {
      font-size: 25px;
    }
    .help-cta {
      padding: 30px 22px;
    }
  }

  @media print {
    .guide-hero {
      background: #ffffff;
      color: ${ink};
    }
  }
`;
